module.exports = __webpack_public_path__ + "img/014-dish.78a49001.png";